/**
 * @generated SignedSource<<505e42f52f069544fc19be9ae47af09b>>
 * @relayHash 4a516532f481795a6fb98a0e01c981b9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3fb282db83bed282d73474fa53054acdf7c575da6ffa5d4a3dec565ba86c9898

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type BlockedAccessSubjectType = "GROUP" | "USER" | "%future added value";
export type ResourceAccessType = "EDIT" | "VIEW" | "%future added value";
export type BlockedAccessSubjectInput = {
  subjectId: string;
  subjectType: BlockedAccessSubjectType;
};
export type ResolveRestrictionsDialogResolveRestrictionsForSubjectsMutation$variables = {
  accessType: ResourceAccessType;
  contentId: AGG$Long;
  spaceRoleId?: string | null | undefined;
  subjects: ReadonlyArray<BlockedAccessSubjectInput | null | undefined>;
};
export type ResolveRestrictionsDialogResolveRestrictionsForSubjectsMutation$data = {
  readonly resolveRestrictionsForSubjects: {
    readonly errors: ReadonlyArray<{
      readonly message: string | null | undefined;
    }>;
    readonly success: boolean;
  } | null | undefined;
};
export type ResolveRestrictionsDialogResolveRestrictionsForSubjectsMutation = {
  response: ResolveRestrictionsDialogResolveRestrictionsForSubjectsMutation$data;
  variables: ResolveRestrictionsDialogResolveRestrictionsForSubjectsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accessType"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceRoleId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "subjects"
},
v4 = [
  {
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "accessType",
            "variableName": "accessType"
          },
          {
            "kind": "Variable",
            "name": "contentId",
            "variableName": "contentId"
          },
          {
            "kind": "Variable",
            "name": "spaceRoleId",
            "variableName": "spaceRoleId"
          },
          {
            "kind": "Variable",
            "name": "subjects",
            "variableName": "subjects"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "ResolveRestrictionsPayload",
    "kind": "LinkedField",
    "name": "resolveRestrictionsForSubjects",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "success"
      },
      {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "message"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ResolveRestrictionsDialogResolveRestrictionsForSubjectsMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "ResolveRestrictionsDialogResolveRestrictionsForSubjectsMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "4a516532f481795a6fb98a0e01c981b9",
    "id": "3fb282db83bed282d73474fa53054acdf7c575da6ffa5d4a3dec565ba86c9898",
    "metadata": {},
    "name": "ResolveRestrictionsDialogResolveRestrictionsForSubjectsMutation",
    "operationKind": "mutation",
    "text": "mutation ResolveRestrictionsDialogResolveRestrictionsForSubjectsMutation($accessType:ResourceAccessType!,$contentId:Long!,$subjects:[BlockedAccessSubjectInput]!,$spaceRoleId:ID){resolveRestrictionsForSubjects(input:{accessType:$accessType,contentId:$contentId,subjects:$subjects,spaceRoleId:$spaceRoleId}){success,errors{message}}}"
  }
};
})();

(node as any).hash = "ff5bb2cdac9b46578fa9fdfee10454ed";

export default node;
